import { render, staticRenderFns } from "./ConfirmationComponent.vue?vue&type=template&id=54072dc2&scoped=true&"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationComponent.vue?vue&type=style&index=0&id=54072dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54072dc2",
  null
  
)

export default component.exports